var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppraisal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data_exploration_black_24dp",
    transform: "translate(0.134 0.134)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5129",
    "data-name": "Rectangle 5129",
    width: 14,
    height: 14,
    transform: "translate(-0.134 -0.134)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10917",
    "data-name": "Path 10917",
    d: "M8.577,13.155a4.574,4.574,0,0,1-3.908-2.2L6.357,9.27l1.882,1.6,2.626-2.621v.9h1.144V6.289H9.15V7.433h.9L8.177,9.31,6.289,7.719,4.177,9.836a4.577,4.577,0,1,1,4.4,3.319Zm4.291.286a.572.572,0,1,1,.572-.572A.574.574,0,0,1,12.869,13.441Z",
    transform: "translate(-1.711 -1.711)",
    fill: "#d34a7c",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10918",
    "data-name": "Path 10918",
    d: "M7.722,2a5.722,5.722,0,0,0,0,11.444H12.3A1.148,1.148,0,0,0,13.444,12.3V7.722A5.724,5.724,0,0,0,7.722,2Zm0,10.3a4.574,4.574,0,0,1-3.908-2.2L5.5,8.414l1.882,1.6L10.011,7.39v.9h1.144V5.433H8.294V6.577h.9L7.321,8.454,5.433,6.864,3.322,8.981a4.577,4.577,0,1,1,4.4,3.319Zm4.291.286a.572.572,0,1,1,.572-.572A.574.574,0,0,1,12.013,12.585Z",
    transform: "translate(-0.856 -0.856)",
    fill: "#d34a7c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppraisal);
export default __webpack_public_path__ + "static/media/appraisal.f6ecd6ef291a705e701a2c3099204997.svg";
export { ForwardRef as ReactComponent };